const encodeListFilterValues = (values: readonly string[]): string => JSON.stringify(values);

const isFilledStringList = (value: unknown): value is string[] =>
	Array.isArray(value) && value.length > 0 && value.every((item) => typeof item === "string" && item !== "");

export const readListFilterValues = (encoded: string | undefined): string[] | null => {
	if (!encoded) return null;
	try {
		const values: unknown = JSON.parse(encoded);
		return isFilledStringList(values) ? values : null;
	} catch {
		return null;
	}
};

export default encodeListFilterValues;
